import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { MetricsService } from '../services/metricsService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      console.log('Attempting to fetch user...');
      try {
        const res = await axios.get('/auth/current_user');
        console.log('User data received:', res.data);
        setUser(res.data);
      } catch (err) {
        console.error('Error fetching user:', err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = () => {
    const loginUrl = process.env.NODE_ENV === 'production'
      ? '/auth/google'
      : 'http://localhost:4600/auth/google';
    window.location.href = loginUrl;
  };

  const logout = async () => {
    await axios.get('/auth/logout');
    // Выход без перезагрузки страницы: чистим клиентский кэш метрик, чтобы
    // следующий пользователь в той же вкладке не получил данные предыдущего
    MetricsService.clearCache();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
